import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import './Footer.css';

const Footer: React.FC = () => {
  const { t } = useLanguage();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer" role="contentinfo">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>{t('footer.company.name')}</h3>
            <p>
              {t('footer.company.description.part1')}
            </p>
            <p>
              {t('footer.company.description.part2')}
            </p>
          </div>

          <div className="footer-section">
            <h4>{t('footer.services.title')}</h4>
            <ul>
              {(t('footer.services.items') as unknown as string[]).map((item: string, index: number) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </div>

          <div className="footer-section">
            <h4>{t('footer.contact.title')}</h4>
            <div className="footer-contact">
              <div className="contact-item">
                <i className="contact-icon">📧</i>
                <a 
                  href={`mailto:${process.env.REACT_APP_CONTACT_EMAIL}`}
                  className="contact-link"
                  aria-label={`${t('footer.contact.emailLabel')} ${process.env.REACT_APP_CONTACT_EMAIL}`}
                >
                  {process.env.REACT_APP_CONTACT_EMAIL}
                </a>
              </div>
              <div className="contact-item">
                <i className="contact-icon">📞</i>
                <a 
                  href={`tel:${process.env.REACT_APP_CONTACT_PHONE}`}
                  className="contact-link"
                  aria-label={`${t('footer.contact.phoneLabel')} ${process.env.REACT_APP_CONTACT_PHONE}`}
                >
                  {process.env.REACT_APP_CONTACT_PHONE}
                </a>
              </div>
            </div>
          </div>

        </div>
        <div className="footer-bottom">
          <p>&copy; {currentYear} {t('footer.copyright.text')}</p>
          <p>{t('footer.copyright.description')}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
